"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderParamsCore = void 0;
/**
 * Represents the default inputs for a data table header.
 */
class HeaderParamsCore {
}
exports.HeaderParamsCore = HeaderParamsCore;
//# sourceMappingURL=header.params.js.map